import { MDBMask, MDBView } from "mdbreact";
import React, { useEffect } from "react";
import { Switch, useLocation, withRouter } from "react-router-dom";
import BlockUi from "./components/modules/block-ui/BlockUi";
import EntryPage from "./components/pages/entry/EntryPage";
import PointCardPage from "./components/pages/point-card/PointCardPage";
import ShopListPage from "./components/pages/shop-list/ShopListPage";
import { AppContainer } from "./containers/App";
import { CampaignContainer } from "./containers/Campaign";
import { ErrorContainer } from "./containers/Error";
import { PointCardContainer } from "./containers/PointCard";
import { UserContainer } from "./containers/User";
import AuthGuardRoute from "./utilities/AuthGuardRoute";
import ErrorBoundary from "./utilities/ErrorBoundary";

/**
 * ページ切り替え時に画面上端にスクロールする処理
 */
const ScrollToTop: React.FC<any> = (props) => {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return props.children;
};
/**
 * 画面上端スクロールの機能コンポーネント
 * <Scroll></Scroll> 内の子コンポーネントは、画面切り替え時に自動で上端にスクロールする。
 */
const Scroll = withRouter(ScrollToTop);

const App: React.FC = () => {
  const appContainer = AppContainer.useContainer();
  const loading = appContainer.context.loading;

  const errorContainer = ErrorContainer.useContainer();
  const hasError = errorContainer.hasError();

  const userContainer = UserContainer.useContainer();
  const user = userContainer.user;
  const userId = user.id || "";

  const campaignContainer = CampaignContainer.useContainer();
  const campaign = campaignContainer.campaign;
  const campaignId = campaignContainer.campaignId;

  const pointCardContainer = PointCardContainer.useContainer();
  const pointCard = pointCardContainer.pointCard;

  if (!appContainer.context.loading && !hasError) {
    if (!campaign) {
      // キャンペーンデータを初期化
      appContainer.setLoading(true);
      campaignContainer
        .initCampaign(campaignId)
        .then(() => appContainer.setLoading(false))
        .catch((error) => errorContainer.setDefaultError(userId, error));
    } else if (!pointCard && user.id && user.hashedId) {
      // ポイントカードデータを初期化
      appContainer.setLoading(true);
      const defaultRecommends = campaign?.setting.defaultRecommends.map(
        (dr: any): string => dr.id
      );
      pointCardContainer
        .initPointCard(
          user.id,
          user.hashedId,
          campaignId,
          defaultRecommends || [],
          user.token || ""
        )
        .then(() => appContainer.setLoading(false))
        .catch((error) => errorContainer.setDefaultError(userId, error));
    }
  }

  return (
    <ErrorBoundary>
      <Scroll>
        <MDBView>
          <Switch>
            <AuthGuardRoute
              path="/:campaignId/point-card/:id"
              component={PointCardPage}
            ></AuthGuardRoute>
            <AuthGuardRoute
              path="/:campaignId/shop-list/:id"
              component={ShopListPage}
            ></AuthGuardRoute>
            <AuthGuardRoute path="**" component={EntryPage}></AuthGuardRoute>
          </Switch>
          {loading ? (
            <MDBMask>
              <BlockUi></BlockUi>
            </MDBMask>
          ) : null}
        </MDBView>
      </Scroll>
    </ErrorBoundary>
  );
};

export default App;
